module.exports = __webpack_public_path__ + "media/images/svg/help/wave-mobile-b94afa27c025d817a19b1a36a6c09858.svg";